import React, { useContext } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import LiteratureCoverLetter from '../../../LiteratureCoverLetter';
import TextualContent from '../../TextualContent';
import { useDeviationViewContext } from '../../../Context';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { getDeviationTitle } from '../../_helpers';
import AutoSizedText from '../_partials/AutoSizedText';
import { normalizePremiumFolderData } from '../../../utils/normalizePremiumFolderData';
import PremiumIconWithPopover from '../_partials/PremiumIconWithPopover';
import DeviationFlags from '../../../ActionBar/buttons/DeviationFlags';
import s from './Literature.scss';
var LiteratureFullView = function (_a) {
    var dailyDeviation = _a.deviation.dailyDeviation, deviation = _a.deviation, width = _a.width, height = _a.height;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    var _b = useDeviationViewContext(), isFullscreen = _b.isFullscreen, isTheater = _b.isTheater;
    var style = (isTheater || isFullscreen) && !isMobile ? { width: width, height: height } : { width: width };
    var _c = normalizePremiumFolderData(deviation === null || deviation === void 0 ? void 0 : deviation.premiumFolderData), isPremium = _c.isPremium, isPaidFolder = _c.isPaidFolder;
    var deviationTitle = getDeviationTitle(deviation);
    return (React.createElement("div", { className: classnames(s['root'], isTheater && s['theater'], isFullscreen && s['fullscreen']), style: style },
        React.createElement("div", { className: s['letter-wrap'] },
            React.createElement("div", { className: s['letter'] },
                React.createElement(LiteratureCoverLetter, { alignment: "start", title: deviationTitle }))),
        React.createElement("div", { className: s['content-wrap'] },
            React.createElement("div", { className: classnames(s['title-wrap'], isMobile && dailyDeviation && s['with-flag']) },
                isMobile && dailyDeviation && (React.createElement("div", { className: s['flag'] },
                    React.createElement(DeviationFlags, { deviation: deviation }))),
                React.createElement("div", { className: s['tag'] },
                    isPremium && (React.createElement(PremiumIconWithPopover, { className: s['premium-icon'], isPaidFolder: isPaidFolder })),
                    t('common.literature')),
                React.createElement(AutoSizedText, { className: s['title'], tooBigClassName: s['better-fit'], maxHeight: 180 }, deviationTitle)),
            isFullscreen && (React.createElement(TextualContent, { deviation: deviation, withArtist: false })))));
};
LiteratureFullView.displayName = 'LiteratureFullView';
export default LiteratureFullView;
//# sourceMappingURL=Literature.js.map